exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spinner-floating-wrapper {\n  z-index: 800;\n  position: fixed;\n  overflow: auto;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  outline: 0;\n  background: rgba(0, 0, 0, 0.5); }\n\n.spinner-floating-loading {\n  left: 50%;\n  z-index: 808;\n  top: 50%;\n  position: absolute;\n  margin-left: -25px; }\n  .spinner-floating-loading i {\n    font-size: 50px;\n    color: white; }\n", ""]);

// exports
